import { Success, Warning, Error, Info } from '@ui/components/icons';
import { NotificationType } from '@interfaces/models';
import { BadgeColor, Badge } from '@ui/components';
import { ReactNode, FC } from 'react';

export interface NotificationBadgeProps {
  severity: NotificationType;
}

export const NotificationBadge: FC<NotificationBadgeProps> = ({ severity }) => {
  const variant: BadgeColor =
    (severity === NotificationType.DANGER && 'critical') ||
    (severity === NotificationType.WARNING && 'warning') ||
    (severity === NotificationType.SUCCESS && 'success') ||
    (severity === NotificationType.INFO && 'blue') ||
    'default';

  const icon: ReactNode =
    (severity === NotificationType.DANGER && <Error />) ||
    (severity === NotificationType.WARNING && <Warning />) ||
    (severity === NotificationType.SUCCESS && <Success />) ||
    (severity === NotificationType.INFO && <Info />) ||
    null;

  return (
    <Badge variant={variant} size="large" icon>
      {icon}
    </Badge>
  );
};
